// src/services/IngredientesService.js
import API from "./Config";

const ENDPOINT = "/ingredientes?skip=0&limit=10000";
const STORAGE_KEY = "ingredientesEnPacientes";

const IngredientesService = {
  /**
   * Devuelve un array con todos los ingredientes.
   * Si ya están en localStorage, los utiliza en lugar de hacer la petición.
   */
  fetchIngredientes: () => {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached) {
      try {
        return Promise.resolve(JSON.parse(cached));
      } catch (e) {
        // si el parse falla, borra cache y continúa
        localStorage.removeItem(STORAGE_KEY);
      }
    }

    return API.get(ENDPOINT)
      .then((res) => {
        const data = res.data;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        return data;
      });
  },

  /**
   * Forzar refresco desde el servidor y actualizar cache
   */
  refreshIngredientes: () => {
    return API.get(ENDPOINT)
      .then((res) => {
        const data = res.data;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        return data;
      });
  }
};

export default IngredientesService;
